const buildType = require("./models");

module.exports = buildType({
  initializer: (model, document) => {
    model.code = document?.code;
    model.name = document?.name;
    model.country = document?.country;
  },
  code: "companies",
  singular: "Company",
  plural: "Companies",
});
